import React from 'react'
import Box from '@mui/joy/Box'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Radio from '@mui/joy/Radio'
import RadioGroup, { type RadioGroupProps } from '@mui/joy/RadioGroup'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import { ParkingType } from '../types'

export default function ParkingTypeSelector({
    value,
    handleChange,
}:{
    value: ParkingType,
    handleChange: RadioGroupProps['onChange'],
}) {

    const { t } = useTranslation()

    return (
        <Box>
            <FormControl>
                <FormLabel><Typography level='title-md'>{t('filters.parkingType')}</Typography></FormLabel>
                <RadioGroup
                    value={value}
                    name="parkingType"
                    orientation="horizontal"
                    onChange={handleChange}
                >
                    <Radio value={ParkingType.all} label={t('filters.all')} />
                    <Radio value={ParkingType.garage} label={t('filters.garage')} />
                    <Radio value={ParkingType.parkingLot} label={t('filters.parkingLot')} />
                </RadioGroup>
            </FormControl>
        </Box>
    )
}